<template>
  <div class="q-gutter-lg">
    <fieldset
      class="q-gutter-lg"
      style="width: 650px max-width: 250px"
    >
      <legend class="text-left text-h5">
        Select Complexes and Units
      </legend>

      <q-separator />
      <q-tree
        default-expand-all
        :nodes="complexTree"
        node-key="key"
        tick-strategy="strict"
        v-model:ticked="ticked"
        v-model:expanded="expanded"
        no-nodes-label="No complexes added, please add complex under complexes tab."
        @update:ticked="(target) => tickUpdate(target)"
      />
    </fieldset>
  </div>
</template>
<script>

import { ref, watch } from 'vue';
import useComplexTree from '@/hooks/complexTree';

export default {
  async setup() {
    const {
      fetchComplexTree, complexTree, ticked, expanded,
    } = useComplexTree();
    const complexKeys = ref([]);
    const complexTicks = ref([]);

    // used to remove children ticked if parent is removed.
    // ticked order does not change, so when we find a value missing from newValue that
    // used to be in oldValue,this must be the removed value, so remove it's children
    watch(ticked, (newValue, oldValue) => {
      if (newValue.length > oldValue.length) {
        return;
      }

      const unTicked = ref('');
      for (let i = 0; i < oldValue.length; i += 1) {
        if (oldValue[i] !== newValue[i]) {
          unTicked.value = oldValue[i];
          break;
        }
      }

      // remove all children of unticked complex
      if (complexKeys.value.includes(unTicked.value)) {
        const unTickedParent = ref([]);
        for (let i = 0; i < complexTree.value.length; i += 1) {
          if (complexTree.value[i].key === unTicked.value) {
            unTickedParent.value = complexTree.value[i];
            break;
          }
        }

        for (let i = 0; i < unTickedParent.value.children.length; i += 1) {
          const index = ticked.value.indexOf(unTickedParent.value.children[i].key);
          if (index !== -1) {
            ticked.value.splice(index, 1);
          }
        }
      }

      // @TODO: untick parent complex if all children are unticked
    });

    await fetchComplexTree();

    for (let i = 0; i < complexTree.value.length; i += 1) {
      if (complexTree.value[i].key.startsWith('Complex')) {
        complexKeys.value.push(complexTree.value[i].key);
        complexTicks.value.push(complexTree.value[i]);
      }
    }

    const tickUpdate = (target) => {
      if (target.length === 0) {
        return;
      }
      const newTick = target[target.length - 1]; // most recently ticked is always at end of array
      if (newTick.startsWith('Complex')) {
        const tickedParent = complexTree.value.filter((x) => x.key === newTick)[0];
        for (let i = 0; i < tickedParent.children.length; i += 1) {
          if (!ticked.value.includes(tickedParent.children[i].key)) {
            ticked.value.push(tickedParent.children[i].key);
          }
        }
      }
    };

    return {
      complexTree,
      ticked,
      tickUpdate,
      expanded,
    };
  },
};
</script>
